import { CaseStudy } from '../../types';

export const rideRoster: CaseStudy = {
  id: '5',
  title: 'Ride Roster',
  category: 'Carpool Logistics',
  imageUrl: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?q=80&w=1200&auto=format&fit=crop',
  description: 'Ride Roster is a simple, reliable way to organise shared rides — without the chaos of endless messages and last-minute confusion.\n\nDesigned for real life, Ride Roster helps families, schools, sports teams, and communities coordinate carpools with clarity and confidence. Create structured schedules, see who’s driving and when, and make shared responsibility easy for everyone involved.\n\nWhether it’s the daily school run, weekend sports fixtures, or regular group activities, Ride Roster replaces informal chats with a clear, shared plan that people can trust. Everyone knows the arrangement. Everyone knows their role. And plans run smoothly.\n\nReliable carpooling, simply organised.',
  screenshots: [],
  hasTermsAndConditions: true,
  hasAccountDeletion: true
};
